<div class="swiper-home-banner">
  <swiper-container appSwiper init="false" [config]="homePageSliderConfig">
    @for (slide of homePageBannerSlides$ | async; track $index) {
      <swiper-slide [innerHTML]="slide.content"></swiper-slide>
    }
  </swiper-container>
  <div class="swiper-button swiper-button-prev">
    <img src="assets/images/icons/arrow-left.svg" alt="" />
  </div>
  <div class="swiper-button swiper-button-next">
    <img src="assets/images/icons/arrow-right.svg" alt="" />
  </div>
</div>

<div class="container">
  @if (productsForHomeCategory$ | async; as productsForHomeCategory) {
    <app-products-slider
      [title]="productsForHomeCategory?.title"
      className="home-page-first"
      [products]="productsForHomeCategory?.products"
      [sliderConfig]="homePageSlider1Config"
    />
  }

  <app-blocks-grid
    [countToShow]="2"
    [blockRows]="1"
    [blockIdentifiers]="blockIdentifiers"
  />

  @if (productsForHomeCategory_2$ | async; as productsForHomeCategory_2) {
    <app-products-slider
      className="home-page-second"
      [title]="productsForHomeCategory_2?.title"
      [products]="productsForHomeCategory_2?.products"
      [sliderConfig]="homePageSlider2Config"
    />
  }
</div>
